export default "__VITE_ASSET__Bqf$niAs__"